import {
  createFileRoute,
  Outlet,
  redirect,
  useNavigate,
} from "@tanstack/react-router";
import { trpc } from "@/lib/trpc";

export const Route = createFileRoute("/admin")({
  beforeLoad: ({ location }) => {
    // Redirect /admin to /admin/users
    if (location.pathname === "/admin") {
      throw redirect({ to: "/admin/users" });
    }
  },
  component: Admin,
});

function Admin() {
  const navigate = useNavigate();
  const { data: user, isLoading } = trpc.user.me.useQuery();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user?.isSuperAdmin) {
    navigate({ to: "/" });
    return null;
  }

  return <Outlet />;
}
